import { QueryClient } from '@tanstack/react-query';

/**
 * Cliente de TanStack Query de la app.
 *
 * Vive fuera de `App.tsx` para que el authStore pueda vaciar el cache al cambiar
 * de sesion sin depender del arbol de React. Este modulo no importa nada del
 * dominio, asi que no genera ciclos.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
      retry: (failureCount, error) => {
        // Don't retry on 4xx errors
        if (error instanceof Error && 'status' in error) {
          const status = (error as Error & { status: number }).status;
          if (status >= 400 && status < 500) return false;
        }
        return failureCount < 3;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
